export function exportCsv(data = [], filename = 'report.csv') {
  if (!data || !Array.isArray(data) || data.length === 0) {
    // Inform the user when there is no data to export
  try { alert('No hay registros disponibles, selecciona fechas válidas y dale clic en el botón BUSCAR para cargar la información'); } catch (e) { /* noop in non-browser env */ }
    return;
  }
  const keys = data.length ? Object.keys(data[0]) : [];
  const escape = (v) => {
    if (v === null || v === undefined) return '';
    const s = String(v).replace(/"/g, '""');
    return `"${s}"`;
  };
  const header = keys.map(k => escape(k)).join(',');
  const rows = data.map(row => keys.map(k => escape(row[k])).join(','));
  const csv = [header].concat(rows).join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  if (link.remove) link.remove(); else document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export async function exportToExcel(data = [], filename = 'report.xlsx') {
  if (!data || !Array.isArray(data) || data.length === 0) {
    // Prefer to inform the user rather than silently returning
  try { alert('No hay registros disponibles, selecciona fechas válidas y dale clic en el botón BUSCAR para cargar la información'); } catch (e) { /* noop */ }
    return;
  }
  try {
    // Prefer any global XLSX already present (e.g., provided by a shim).
    let lib = (typeof globalThis !== 'undefined' && globalThis.XLSX && globalThis.XLSX.utils) ? globalThis.XLSX : null;
    if (!lib) {
      // Dynamically import SheetJS only when needed. This creates a separate
      // chunk and keeps the main bundle small.
      const mod = await import(/* webpackChunkName: "xlsx" */ 'xlsx');
      lib = (mod && mod.default) ? mod.default : mod;
    }
    if (!lib || !lib.utils) throw new Error('XLSX library not available');

    const ws = lib.utils.json_to_sheet(data);
    const wb = lib.utils.book_new();
    lib.utils.book_append_sheet(wb, ws, 'Sheet1');
    const wbout = lib.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    if (link.remove) link.remove(); else document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (err) {
    // fallback to CSV if dynamic import or xlsx usage fails
    try {
      exportCsv(data, filename.replace(/\.xlsx?$/, '.csv'));
    } catch (e) {
      // swallow
    }
  }
}
